import { Table } from '@tanstack/react-table'

import { Log, FilterType, DailyLogCode, MileageLossCode } from '@/types/logs'
import { extractParts, compareValueWithPrefix } from '@/helpers/compareValueWithPrefix'

const dailyLogCodes: string[] = Object.values(DailyLogCode)

export const formatDutyFilterValues = (
    values: string[],
    table: Table<Log>,
    filter: FilterType = FilterType.All
): string[] => {
    const availableDuties: string[] = table.getCoreRowModel().rows.reduce<string[]>((acc, row) => {
        if (!row.original.duty) {
            return acc
        }

        if (filter === FilterType.DailyLog && dailyLogCodes.includes(row.original.code)) {
            acc.push(...row.original.duty)
        }

        if (filter === FilterType.MileageLoss && row.original.code in MileageLossCode) {
            acc.push(...row.original.duty)
        }

        if (filter === FilterType.All) {
            acc.push(...row.original.duty)
        }

        return acc
    }, [])

    const filteredValues = values.reduce<string[]>(
        (acc, duty) => (availableDuties.includes(duty) ? [...acc, duty] : acc),
        []
    )

    return filteredValues.sort((a, b) => {
        const [prefixA, numA, suffixA] = extractParts(a)
        const [prefixB, numB, suffixB] = extractParts(b)

        return compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
    })
}
